/**
 * @fileoverview Agent definition for world-object-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world object's details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.objects.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-object-details-ideation-v3',
  kind: 'primitive',
  name: 'World Object Details Ideation',
  description: 'Generates creative directions for developing a world object before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    taxonomyPath: 'world-building.objects.details',
    usedBy: [
      'use-world-object-details-ideation-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'world-object-details-generator-v3',
    ],
  },
};
